import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { STEP_STATUS_TOOLTIPS } from 'constants/status-tooltip.constants';
import { ComputedFrom } from '@certemy/common';
import { STEP_TYPES, STEP_COLOR_STATUSES } from 'constants/status.constants';

const DEFAULT_STEP_ICON_NAME = 'dynamic-form';

@Component({
  selector: 'cm-step-icon',
  templateUrl: './step-icon.component.html',
  styleUrls: ['./step-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepIconComponent {
  @Input() statusColor: STEP_COLOR_STATUSES;
  @Input() stepType: STEP_TYPES;
  @Input() tooltipHidden = false;
  readonly stepIconName = {
    [STEP_TYPES.FEES]: 'fee-step',
    [STEP_TYPES.OTHER_CERTIFICATE]: 'arrow-in-circle',
    [STEP_TYPES.EVIDENCE_FILE]: 'evidence-file',
    [STEP_TYPES.EDUCATION]: 'education-step',
    [STEP_TYPES.TEST]: 'test-step',
    [STEP_TYPES.REGISTRATION_FORM]: 'reg-form-step',
    [STEP_TYPES.VERIFICATION]: 'verification-step',
    [STEP_TYPES.LOG]: 'log-step',
    [STEP_TYPES.LOG_NEW]: 'log-step',
    [STEP_TYPES.PRACTICE_TEST]: 'test-step',
    [STEP_TYPES.TEST_REGISTRATION_VERIFICATION]: 'verification-step',
    [STEP_TYPES.TEST_FEE]: 'fee-step',
    [STEP_TYPES.SCHEDULING]: 'test-step',
    [STEP_TYPES.TEST_SCHEDULING_VERIFICATION]: 'verification-step',
    [STEP_TYPES.TEST_TAKING]: 'test-step',
    [STEP_TYPES.TEST_TAKING_VERIFICATION]: 'verification-step',
    [STEP_TYPES.TEST_SCORE]: 'test-step',
    [STEP_TYPES.TEST_SCORE_VALIDATION]: 'verification-step',
  };

  stepWithoutStatus = [STEP_TYPES.PRACTICE_TEST, STEP_TYPES.SCHEDULING, STEP_TYPES.TEST_TAKING];

  @ComputedFrom('stepType')
  get iconName(): string {
    return this.stepIconName[this.stepType] || DEFAULT_STEP_ICON_NAME;
  }

  @ComputedFrom('tooltipHidden', 'statusColor')
  get tooltip() {
    return !this.tooltipHidden ? STEP_STATUS_TOOLTIPS[this.statusColor] : null;
  }
}
